import { Typography, styled, type TypographyProps, type TypographyTypeMap } from '@mui/material';
import { type OverridableComponent } from '@mui/material/OverridableComponent';

const SectionTitle = styled<OverridableComponent<TypographyTypeMap<{}, 'span'>>>((props: TypographyProps) => (
  <Typography variant="h2" {...props} />
))(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 400,
  lineHeight: 1,
  letterSpacing: -1
}));

export default SectionTitle;
